import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Ui::Card @expandOnMobile={{true}} class=\'card--tab-bar\'>\n  <Ui::NavigationBar ...attributes as |Item|>\n    {{yield Item}}\n  </Ui::NavigationBar>\n</Ui::Card>")